import styles from './FJMediaPreview.module.less';
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import FJVideoContent from '../../../../common/components/FJVideoPlayer/FJVideoContent.jsx';
import FJImageItemPreview from '../../../../common/components/FJImageItemPreview/FJImageItemPreview.jsx';
import PropTypes from 'prop-types';
const space = 90;

const fitSize = (ratio, outerSize, float = true) => {
    let r1 = ratio;
    let r2 = outerSize.width / outerSize.height;
    let w, h;
    if (r1 >= r2) {
        w = outerSize.width;
        h = w / r1;
    } else {
        h = outerSize.height;
        w = h * r1;
    }
    if (float) {
        return { width: w, height: h };
    } else {
        return { width: Math.floor(w), height: Math.floor(h) };
    }
};

const FJMediaPreview = props => {
    const { info } = props;
    const { videoUrl, ratio, imgUrl, width, height, jobType } = info;
    const isImage = [3, 6, 36].includes(jobType);

    const containerRef = useRef(null);
    const [viewSize, setViewSize] = useState({ width: 0, height: 0 });

    const _updateViewSize = useCallback(() => {
        const containerRect = containerRef.current.getBoundingClientRect();
        if (ratio) {
            const tempRect = fitSize(ratio, {
                width: containerRect.width - space * 2,
                height: containerRect.height - space * 2,
            });

            setViewSize(tempRect);
        } else if (width && height) {
            const tempRect = fitSize(width / height, {
                width: containerRect.width - space * 2,
                height: containerRect.height - space * 2,
            });

            setViewSize(tempRect);
        }
    }, [ratio, width, height]);

    useLayoutEffect(() => {
        setTimeout(() => {
            _updateViewSize();
        }, 200);
    }, [_updateViewSize, videoUrl, imgUrl]);

    useEffect(() => {
        window.addEventListener('resize', _updateViewSize);
        return () => {
            window.removeEventListener('resize', _updateViewSize);
        };
    }, []);

    return (
        <div ref={containerRef} className={styles.box}>
            {isImage && (
                <div className={styles.img_box} style={{ width: viewSize.width, height: viewSize.height }}>
                    <FJImageItemPreview imgUrl={imgUrl} isShowShareIcon={false} />
                </div>
            )}
            {!isImage && (
                <FJVideoContent
                    url={videoUrl}
                    isLoop={true}
                    ratio={ratio}
                    isShowFullScreen={true}
                    viewSize={viewSize}
                    style={{ borderRadius: '20px' }}
                />
            )}
        </div>
    );
};

FJMediaPreview.propTypes = {
    info: PropTypes.object,
};

export default FJMediaPreview;
